export default __webpack_public_path__ + "static/media/DAVID.f5811e85.png";